import React from 'react'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

class Home extends React.Component {
  render() {
    return (
      <div>
        <Paper style={{ padding: "7px" }}>
          <Typography variant="h5" color="textPrimary" >Home</Typography>
          <Divider style={{margin: "10px"}} />
          <Typography variant="body1" color="textPrimary" gutterBottom>
            Hello there!
            </Typography>
        </Paper>
      </div>
    )
  }
}

export default (Home)